<efx-footer [leftLogo]="leftLogo" [rightLogo]="rightLogo">
  <div class="container_up" style="display: none"></div>
  <div class="copyright">
    <p>
      Copyright {{year}} Equifax Inc. Todos los derechos reservados. Equifax y las
      marcas de Equifax utilizadas en este documento son marcas comerciales de
      Equifax Inc. Los demás nombres de productos y empresas mencionados en este
      documento son propiedad de sus respectivos dueños.
    </p>
  </div>
</efx-footer>